<template>
  <div>
    <div class="ERP_modal" id="modal" v-show="tipsType">
      <a-modal
        :visible="showERPModal"
        :getContainer="getContainer"
        :footer="null"
        :closable="false"
        :centered="true"
        :maskClosable="false"
        width="492px"
      >
        <div class="modalBox" :class="tipsType == 2 ? 'order-end' : 'capacity-end'">
          <div v-if="tipsType == 2">
            <div class="title">ERP单量已用完</div>
            <p class="text">您的ERP单量已用完，为了避免影响团队的正常使用，请尽快完成续费</p>
          </div>
          <div v-else>
            <div class="title">ERP已经到期</div>
            <p class="text">您当前服务已经过期，过期后将无法使用易仓科技服务。为了避免影响团队的正常使用，请尽快完成续费</p>
          </div>
          <div class="buy_btn" @click="open">立即续费</div>
          <div class="click_btn" @click="showERPModal = false; showTips = true">我知道了</div>
        </div>
      </a-modal>
      <div v-if="showTips">
        <div class="tipsMask"></div>
        <div class="tipsCont">
          <div class="txt">点击上方头像，进入“产品套餐“页面，即可进行续费等操作。</div>
          <div><img src="../../assets/close-fill.png" class="closeTips" @click="showTips=false" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RenewalReminder } from '@/api/index'

export default {
  data () {
    return {
      showERPModal: true,
      showTips: false,
      tipsType: ''
    }
  },
  methods: {
    getContainer () {
      return document.getElementById('modal')
    },
    open () {
      this.showERPModal = false
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        ignore: true,
        path: `/entry/${serviceId}/${systemCode}/sso-web#/user/product-package`,
        menuName: {
          zh_CN: '产品套餐',
          en_US: 'Product Package',
          ko_KR: '상품 패키지'
        }
      })
    },
    // 续费提醒接口
    _renewalReminder () {
      RenewalReminder().then(({ data }) => {
        if (data == null) {
          this.tipsType = ''
        } else {
          this.tipsType = data.type
        }
      })
    }
  },
  computed: {

  },
  watch: {

  },
  mounted () {
    this._renewalReminder()
  }
}
</script>

<style lang="less">
.ERP_modal {
  .home-ant-modal-root div[aria-hidden="true"] {
    display: none !important;
  }
  .home-ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.6);
  }
  // .home-ant-modal-mask, .home-ant-modal-wrap {
  //   top: 42px;
  // }
  .home-ant-modal-content{
    border-radius: 12px;
    background: none;
  }
  .home-ant-modal-body{
    padding: 0;
  }
  .modalBox {
    width: 100%;
    height: 520px;
    background-repeat: no-repeat;
  }
  .capacity-end {
    background-image: url('../../assets/capacity_end.png');
  }
  .order-end {
    background-image: url('../../assets/order_end.png');
  }
  .title {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #3e86ff;
    margin-bottom: 15px;
    padding-top: 250px;
  }
  .text {
    text-align: center;
    color: #818181;
    line-height: 26px;
    padding: 0 42px;
  }
  .buy_btn {
    width: 240px;
    height: 50px;
    line-height: 50px;
    color: #fff;
    margin: 30px auto 20px;
    background: linear-gradient(90deg, #4E94FC, #58AAFF);
    box-shadow: 1px 5px 1px 0px #74aef399;
    border-radius: 28px;
    text-align: center;
    font-size: 18px;
    cursor: pointer;
  }
  .click_btn {
    text-align: center;
    color: #a4a4a4;
    cursor: pointer;
  }
  .tipsMask {
    position: fixed;
    // top: 42px;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .tipsCont {
    width:245px;
    height:70px;
    background:url('../../assets/tipsBg.png') center no-repeat;
    position: absolute;
    top:50px;
    right:5px;
    z-index:101;
    padding: 21px 10px 0;
    font-size: 12px;
    .closeTips {
      position: absolute;
      top:-8px;
      right:3px;
      z-index:9999;
      cursor:pointer;
    }
  }
}
</style>
